import React from 'react';
import styled from '@emotion/styled';
// import Img from 'gatsby-image';
import PropTypes from 'prop-types';


const Wrapper = styled.div`
    position: relative;
    display:block;
    text-align:center;
`;

const Imgdiv = styled.div`

  margin-top:0.5rem;
  
  img {
    object-fit: cover;
    width:40vw;
    max-width:100%;
    height:40vw;
    max-height:100%;
    border-radius: 100%;
    margin-bottom:0;
  }

  @media (min-width:${props => props.theme.breakpoints.sm}) {
        img {
          width:80%;
          height:100%;
          border-radius: 80px;
            }
  }

  @media (min-width:${props => props.theme.breakpoints.md}) {   
        img {
        width:60%;
            }
  }
`;

const Text = styled.div`

  color: black;
  z-index: 0;
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  max-width: ${props => props.theme.layout.base};
  padding: 0 2rem;
  margin:　auto;
  align-items: center;
  h1 {
    font-size:6vw;
    margin-bottom: 4rem;
  }

  @media (min-width:${props => props.theme.breakpoints.sm}) {
    color: white;
    top: 50%;
    margin-bottom: auto;
    h1 {
      font-size:3rem;
    }
  }
`;


const Detail = styled.div`
  color: black;
  text-align: center;
  align-items: center;
  margin-left:30px;
  margin-right:30px;
`;

// cover→SampleImage

const PartyDetail = ({ image,title }) => (
  <Wrapper>
  <Imgdiv>
    <img src={image} alt={title} />
    </Imgdiv>
    <Text>
      <h1>{title}</h1>
    </Text>
  </Wrapper>
)
export default PartyDetail;

PartyDetail.defaultProps = {
  cover: false,
  title: false,
};

